// 轻量替代 Element UI 的 $message / $confirm（保持兼容签名，调用点无需改动）。
// 仅用原生 DOM，样式见 assets/styles/ui.scss。图标用内联 SVG，不依赖 element-icons 字体。

const SVG = 'xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"'
const PATH = {
  success: '<circle cx="12" cy="12" r="9"/><path d="M8.5 12.5l2.3 2.3 4.7-5"/>',
  error: '<circle cx="12" cy="12" r="9"/><path d="M9 9l6 6M15 9l-6 6"/>',
  warning: '<path d="M12 3l9 16H3z"/><path d="M12 10v4M12 17v.5"/>',
  info: '<circle cx="12" cy="12" r="9"/><path d="M12 11v5M12 8v.5"/>'
}

function toastIcon(type) {
  const i = document.createElement('i')
  const key = PATH[type] ? type : 'info'
  i.innerHTML = '<svg class="nr-icon" ' + SVG + '>' + PATH[key] + '</svg>'
  return i
}

function toastRoot() {
  let root = document.querySelector('.nr-toast-root')
  if (!root) {
    root = document.createElement('div')
    root.className = 'nr-toast-root'
    document.body.appendChild(root)
  }
  return root
}

function toast(opts) {
  if (typeof opts === 'string') opts = { message: opts }
  const { message = '', type = 'info', duration = 2500 } = opts || {}
  const el = document.createElement('div')
  el.className = 'nr-toast nr-toast--' + type
  const icon = toastIcon(type)
  const span = document.createElement('span')
  span.textContent = message
  el.appendChild(icon)
  el.appendChild(span)
  toastRoot().appendChild(el)
  requestAnimationFrame(() => el.classList.add('show'))
  setTimeout(() => {
    el.classList.remove('show')
    setTimeout(() => el.remove(), 200)
  }, duration)
}
;['success', 'error', 'warning', 'info'].forEach(t => {
  toast[t] = m => toast(typeof m === 'string' ? { message: m, type: t } : { ...(m || {}), type: t })
})

// $confirm(message, title?, opts?) → Promise，确认 resolve('confirm')，取消 reject('cancel')
function confirm(message, title = '提示', opts = {}) {
  if (typeof title === 'object' && title !== null) {
    opts = title
    title = '提示'
  }
  const { confirmButtonText = '确定', cancelButtonText = '取消' } = opts || {}
  return new Promise((resolve, reject) => {
    const overlay = document.createElement('div')
    overlay.className = 'nr-modal-overlay'
    const box = document.createElement('div')
    box.className = 'nr-confirm'

    const h = document.createElement('div')
    h.className = 'nr-confirm__title'
    h.textContent = title
    const m = document.createElement('div')
    m.className = 'nr-confirm__msg'
    m.textContent = message
    const actions = document.createElement('div')
    actions.className = 'nr-confirm__actions'
    const cancel = document.createElement('button')
    cancel.className = 'btn'
    cancel.textContent = cancelButtonText
    const ok = document.createElement('button')
    ok.className = 'btn btn--primary'
    ok.textContent = confirmButtonText
    actions.appendChild(cancel)
    actions.appendChild(ok)
    box.appendChild(h)
    box.appendChild(m)
    box.appendChild(actions)
    overlay.appendChild(box)
    document.body.appendChild(overlay)

    const close = () => overlay.remove()
    ok.onclick = () => { close(); resolve('confirm') }
    cancel.onclick = () => { close(); reject('cancel') }
    overlay.onclick = e => { if (e.target === overlay) { close(); reject('cancel') } }
  })
}

export { toast as message, confirm }

export default {
  install(Vue) {
    Vue.prototype.$message = toast
    Vue.prototype.$confirm = confirm
  }
}
